import { __rest } from 'tslib';
import React from 'react';
import { styled, Overlay } from '@teko/ui';
import { LogoLoading } from './LogoLoading.es.js';

const StyledOverLay = styled(Overlay) `
  background: rgba(0, 0, 0, 0.03);
`;
const Loading = (_a) => {
    var { isLoading, children, logo } = _a, props = __rest(_a, ["isLoading", "children", "logo"]);
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledOverLay, Object.assign({}, props, { show: isLoading }),
            React.createElement(LogoLoading, { logo: logo })),
        children));
};

export { Loading };
